// ====================================================================
// ziven-theme-aura v0.2.12 modifyHeaderLogo.js
// ====================================================================
//
// 移动端未登录 bjxy logo 替换 (辉哥 2026-09-03 10:21 + 21:48 反馈, 从 bjxy 扩展迁移到 ziven-theme-aura)
//   现象: vendor forum.blade.php L14-22 渲染 #drawer > header#header > div.Header-title > a#home-link
//     未登录时显示 forum.title 文字 (如 '极客雪域'), 跟 bjxy 品牌 '北极雪屿' 不符
//   修法: 监听 #drawer 子节点变化, 未登录 + bjxy_brand_logo_url 有值时, 替换 #home-link innerHTML 为 <img class="aura-header-logo" />
//   通用: 任何 ziven 项目 (bjxy / geek.ski / 未来) 只要有 bjxy_brand_logo_url setting, ziven-theme-aura 都生效
//   注: bjxy_brand_logo_url setting 仍由 bjxy 扩展 serialize (extending BjyX extend.php),
//       ziven-theme-aura 只读取 app.forum.attribute('bjxy_brand_logo_url')
//   配套 less 段: .aura-header-logo 64x64 圆角 + 居中 + padding 24/18/16 (参考 .App-drawer-aura-user-block)
//
// 适用: 任何 ziven 项目想在 bjxy 路由 + 未登录状态覆盖 vendor Header-title 显示自家 logo
// 注: mobile 端只, 桌面端不动 (桌面端 .Header-title 居中, bjxy logo 也会居中)
// ====================================================================

function applyAuraHeaderLogo() {
  try {
    const isGuest = !app || !app.session || !app.session.user;
    const logoUrl = app && app.forum && app.forum.attribute && app.forum.attribute('bjxy_brand_logo_url');
    // 辉哥 2026-09-04 09:53 反馈: 桌面端 logo 撑爆 52px 顶栏
    // 修法: 桌面端 (>= 768px) 保持 Flarum 原生样式, 不替换 logo
    // 兑现 v0.2.12 commit 418c783 注释承诺 "适用 mobile 端只, 桌面端不动"
    // 配套 less 段不用改: .aura-header-logo 64x64 圆角 / #drawer Header-title padding 24/18/16
    //   / #home-link:has(.aura-header-logo) .Header-logo display:none 都不生效 (桌面端不注入 aura-header-logo)
    // v0.2.8 r.33: 768 → 992 (平板 = 手机版式)
    //   前提: ziven-core 的 shim @phone 现在是 (max-width: 991.98px) —— 用户拍板「平板 = 手机版式」
    //     ⇒ 768~991px 归手机版式, 抽屉里的品牌大 logo 也要跟手机完全一致 (64x64 的 .aura-header-logo).
    //   为什么改: 旧断点 768 的前提是「768px 起就是桌面顶栏」; 现在 768~991 是平板手机版式,
    //     顶栏会塌成抽屉形态, 若这里还按桌面处理就拿不到 aura 的大 logo ⇒ 平板跟手机不一致.
    //   ⇒ 桌面端 (>= 992px) 依旧保持 Flarum 原生 logo 不动 ⇒ 桌面零变化;
    //     与手机区 ≤991.98 无缝衔接 ⇒ 手机区 ≤991.98 / 桌面区 ≥992, 中间无空档.
    if (typeof window !== 'undefined' && window.innerWidth >= 992) return;
    if (!isGuest || !logoUrl) return;
    const homeLink = document.getElementById('home-link');
    if (!homeLink) return;

    // 避免重复替换
    if (homeLink.querySelector('img.aura-header-logo')) return;

    // 替换 #home-link innerHTML 为 bjxy logo
    // 用 a#home-link 节点保持 vendor 链接 + 替换内部 img
    const img = document.createElement('img');
    img.src = logoUrl;
    img.alt = app.forum.attribute('bjxy_brand_name') || 'bjxy';
    img.className = 'aura-header-logo';
    img.loading = 'eager';
    // 清空 #home-link 内容, 插入新 img
    while (homeLink.firstChild) homeLink.removeChild(homeLink.firstChild);
    homeLink.appendChild(img);
  } catch (e) {
    // 静默失败
  }
}
function installAuraHeaderLogo() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__zivenAuraHeaderLogoInstalled) return;
  window.__zivenAuraHeaderLogoInstalled = true;

  // 首次跑 (vendor mithril mount 后)
  if (document.readyState === 'complete') {
    setTimeout(applyAuraHeaderLogo, 0);
  } else {
    window.addEventListener('load', () => setTimeout(applyAuraHeaderLogo, 0));
  }

  // 监听 vendor mithril 可能重新 mount 改 #home-link 内容
  //   - mithril 路由切换时 vendor 重新 mount #app-navigation / #header-primary / #header-secondary
  //   - 但 #drawer > header#header > .Header-title > #home-link 是 server-side 渲染, vendor mithril 不会改
  //   - 保险起见加 MutationObserver 监听 #drawer 子节点变化
  const observer = new MutationObserver(() => {
    applyAuraHeaderLogo();
  });
  const drawer = document.getElementById('drawer');
  if (drawer) {
    observer.observe(drawer, {
      childList: true,
      subtree: true
    });
  } else {
    // 兜底: 等 #drawer mount 后监听
    const drawerWait = setInterval(() => {
      const d = document.getElementById('drawer');
      if (d) {
        clearInterval(drawerWait);
        observer.observe(d, {
          childList: true,
          subtree: true
        });
        applyAuraHeaderLogo();
      }
    }, 100);
    setTimeout(() => clearInterval(drawerWait), 5000);
  }
}
export default function modifyHeaderLogo() {
  installAuraHeaderLogo();
}